import { BalStepItem, BalSteps } from "@baloise/ds-react";
import { useTranslation } from "gatsby-plugin-react-i18next";
import React from "react";

import { StepsProps } from "./steps.types";

/**
 * steps
 */
const Steps: React.FC<StepsProps> = ({ tabs, currentPage }) => {
    const { t } = useTranslation();

    const chapterIsDone = (chapter: string) =>
        Number(chapter) < Number(currentPage?.chapter);

    return (
        <div className="py-x-large bg-grey-1">
            <div className="container is-compact">
                <BalSteps
                    value={currentPage?.chapter}
                    className="lg-stepper"
                    clickable={false}
                >
                    {tabs.map((tab, $index) => {
                        const chapterDone = chapterIsDone(tab.value);

                        return (
                            <BalStepItem
                                key={$index}
                                value={tab.value}
                                label={t<string>(tab.label)}
                                done={chapterDone}
                                disabled={
                                    Number(tab.value) >
                                    Number(currentPage?.chapter)
                                }
                            />
                        );
                    })}
                </BalSteps>
            </div>
        </div>
    );
};

export default Steps;
